import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

const FeedbackButton = () => {
  const { lng } = useParams()
  const [showButton, setShowButton] = useState(false)
  const { t } = useTranslation()
  const handleScroll = () => {
    const scrollPosition = window.scrollY
    const pageHeight = document.documentElement.scrollHeight - window.innerHeight
    const scrollPercentage = (scrollPosition / pageHeight) * 100

    if (scrollPercentage > 50) {
      setShowButton(true)
    } else {
      setShowButton(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    showButton && (
      <Link
        to={`/${lng}/feedbacks`}
        title="استبيان لاستطلاع الرأي"
        className="z-10 flex px-4 py-2 font-bold text-white delay-700 bottom-2 left-2 animate-bounce bg-primary-600"
      >
        {t('your_opinion_matters')}
      </Link>
    )
  )
}

export default FeedbackButton
